// @ts-nocheck
import type { Question } from '../types';

export const vehicleDocumentationQuestions: Question[] = [
  {
    id: 'q-vd-1',
    topic: 'General',
    question: 'What documents must you carry when driving in the Netherlands?',
    options: [
      { id: 'q-vd-1o1', text: 'Only driving license' },
      { id: 'q-vd-1o2', text: 'Driving license and vehicle registration document' },
      { id: 'q-vd-1o3', text: 'Driving license, vehicle registration, insurance certificate, and MOT certificate' }
    ],
    answerId: 'q-vd-1o3',
    explanation: 'You must carry your driving license, vehicle registration document (kentekenbewijs), insurance certificate, and MOT certificate (APK) when driving. (RVV 1990 art. 108)',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-2',
    topic: 'General',
    question: 'What is the APK (Algemene Periodieke Keuring)?',
    options: [
      { id: 'q-vd-2o1', text: 'Annual vehicle insurance check' },
      { id: 'q-vd-2o2', text: 'Annual vehicle safety and emissions test' },
      { id: 'q-vd-2o3', text: 'Annual driving license renewal' }
    ],
    answerId: 'q-vd-2o2',
    explanation: 'APK (Algemene Periodieke Keuring) is the annual vehicle safety and emissions test that all vehicles must pass to be roadworthy.',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-3',
    topic: 'General',
    question: 'How often must a new car have an APK test?',
    options: [
      { id: 'q-vd-3o1', text: 'Every year' },
      { id: 'q-vd-3o2', text: 'Every 2 years' },
      { id: 'q-vd-3o3', text: 'Every 3 years' }
    ],
    answerId: 'q-vd-3o3',
    explanation: 'A new car must have its first APK test after 3 years, then every year thereafter.',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-4',
    topic: 'General',
    question: 'What happens if you drive without valid insurance?',
    options: [
      { id: 'q-vd-4o1', text: 'Warning only' },
      { id: 'q-vd-4o2', text: 'Fine of €140' },
      { id: 'q-vd-4o3', text: 'Heavy fine and possible vehicle confiscation' }
    ],
    answerId: 'q-vd-4o3',
    explanation: 'Driving without valid insurance results in a heavy fine and possible vehicle confiscation. It is a serious offense. (RVV 1990 art. 107)',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-5',
    topic: 'General',
    question: 'What is the minimum insurance coverage required in the Netherlands?',
    options: [
      { id: 'q-vd-5o1', text: 'Third-party liability only' },
      { id: 'q-vd-5o2', text: 'Third-party liability and theft' },
      { id: 'q-vd-5o3', text: 'Comprehensive coverage' }
    ],
    answerId: 'q-vd-5o1',
    explanation: 'The minimum insurance coverage required in the Netherlands is third-party liability insurance (WA-verzekering). (RVV 1990 art. 107)',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-6',
    topic: 'General',
    question: 'What should you do if you lose your driving license?',
    options: [
      { id: 'q-vd-6o1', text: 'Continue driving normally' },
      { id: 'q-vd-6o2', text: 'Report it to the police and apply for a replacement' },
      { id: 'q-vd-6o3', text: 'Wait until you find it' }
    ],
    answerId: 'q-vd-6o2',
    explanation: 'If you lose your driving license, you should report it to the police and apply for a replacement at your local municipality.',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-7',
    topic: 'General',
    question: 'What is the penalty for driving without a valid driving license?',
    options: [
      { id: 'q-vd-7o1', text: 'Warning only' },
      { id: 'q-vd-7o2', text: 'Fine of €140' },
      { id: 'q-vd-7o3', text: 'Heavy fine and possible imprisonment' }
    ],
    answerId: 'q-vd-7o3',
    explanation: 'Driving without a valid driving license is a serious offense that can result in a heavy fine and possible imprisonment.',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-8',
    topic: 'General',
    question: 'What should you do if your vehicle registration document is stolen?',
    options: [
      { id: 'q-vd-8o1', text: 'Continue driving normally' },
      { id: 'q-vd-8o2', text: 'Report it to the police and apply for a replacement' },
      { id: 'q-vd-8o3', text: 'Wait until you find it' }
    ],
    answerId: 'q-vd-8o2',
    explanation: 'If your vehicle registration document is stolen, you should report it to the police and apply for a replacement at the RDW.',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-9',
    topic: 'General',
    question: 'What is the RDW (Rijksdienst voor het Wegverkeer)?',
    options: [
      { id: 'q-vd-9o1', text: 'Dutch driving school association' },
      { id: 'q-vd-9o2', text: 'Dutch vehicle registration and licensing authority' },
      { id: 'q-vd-9o3', text: 'Dutch insurance company' }
    ],
    answerId: 'q-vd-9o2',
    explanation: 'The RDW (Rijksdienst voor het Wegverkeer) is the Dutch vehicle registration and licensing authority responsible for vehicle documentation.',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-10',
    topic: 'General',
    question: 'What should you do if you buy a used car?',
    options: [
      { id: 'q-vd-10o1', text: 'Transfer ownership immediately' },
      { id: 'q-vd-10o2', text: 'Transfer ownership within 14 days' },
      { id: 'q-vd-10o3', text: 'Transfer ownership within 30 days' }
    ],
    answerId: 'q-vd-10o2',
    explanation: 'When you buy a used car, you must transfer ownership within 14 days at the RDW or a post office.',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-11',
    topic: 'General',
    question: 'What happens if you fail to transfer vehicle ownership on time?',
    options: [
      { id: 'q-vd-11o1', text: 'No penalty' },
      { id: 'q-vd-11o2', text: 'Small fine' },
      { id: 'q-vd-11o3', text: 'Fine of €340' }
    ],
    answerId: 'q-vd-11o3',
    explanation: 'Failing to transfer vehicle ownership within 14 days results in a fine of €340.',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-12',
    topic: 'General',
    question: 'What should you do if you move to a different address?',
    options: [
      { id: 'q-vd-12o1', text: 'Update your driving license address' },
      { id: 'q-vd-12o2', text: 'Update your vehicle registration address' },
      { id: 'q-vd-12o3', text: 'Update both driving license and vehicle registration addresses' }
    ],
    answerId: 'q-vd-12o3',
    explanation: 'When you move to a different address, you must update both your driving license and vehicle registration addresses at your local municipality.',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-13',
    topic: 'General',
    question: 'What is the MOT (APK) inspection for vehicles in the Netherlands?',
    options: [
      { id: 'q-vd-13o1', text: 'Annual insurance inspection' },
      { id: 'q-vd-13o2', text: 'Biennial roadworthiness and emissions inspection' },
      { id: 'q-vd-13o3', text: 'Monthly brake inspection' }
    ],
    answerId: 'q-vd-13o2',
    explanation: 'The APK (Algemene Periodieke Keuring) is the biennial roadworthiness and emissions inspection required for all vehicles in the Netherlands to ensure they meet safety and environmental standards.',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-14',
    topic: 'General',
    question: 'What documents must you carry while driving a vehicle?',
    options: [
      { id: 'q-vd-14o1', text: 'Only your driving license' },
      { id: 'q-vd-14o2', text: 'Driving license, vehicle registration, and insurance documents' },
      { id: 'q-vd-14o3', text: 'Only vehicle registration' }
    ],
    answerId: 'q-vd-14o2',
    explanation: 'While driving, you must carry your valid driving license, vehicle registration document (inschrijving), and proof of insurance. You must present these upon request to law enforcement. (RVV 1990 art. 108)',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-15',
    topic: 'General',
    question: 'What is a GB plate on a vehicle registration plate?',
    options: [
      { id: 'q-vd-15o1', text: 'Indicates the vehicle is from Germany' },
      { id: 'q-vd-15o2', text: 'Indicates the vehicle is from Great Britain or the UK' },
      { id: 'q-vd-15o3', text: 'Indicates the vehicle is an electric vehicle' }
    ],
    answerId: 'q-vd-15o2',
    explanation: 'The GB identifier on a registration plate indicates the vehicle is from Great Britain or the UK. This is displayed on the left side of the plate.',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-16',
    topic: 'General',
    question: 'How long is a driving license valid in the Netherlands?',
    options: [
      { id: 'q-vd-16o1', text: '5 years' },
      { id: 'q-vd-16o2', text: '10 years' },
      { id: 'q-vd-16o3', text: 'Varies by age; 5 years under 45, 10 years from 45 and older' }
    ],
    answerId: 'q-vd-16o3',
    explanation: 'Dutch driving licenses are valid for 5 years if the holder is under 45 years old, and for 10 years if the holder is 45 years or older. After this period, the license must be renewed.',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-17',
    topic: 'General',
    question: 'What is third-party liability insurance?',
    options: [
      { id: 'q-vd-17o1', text: 'Insurance covering damage to your own vehicle only' },
      { id: 'q-vd-17o2', text: 'Mandatory insurance covering damage or injury caused to other people' },
      { id: 'q-vd-17o3', text: 'Insurance covering medical expenses only' }
    ],
    answerId: 'q-vd-17o2',
    explanation: 'Third-party liability insurance is the mandatory minimum insurance in the Netherlands that covers damage or injuries you cause to other people. It does not cover damage to your own vehicle. (RVV 1990 art. 107)',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-18',
    topic: 'General',
    question: 'What should you do if your insurance policy expires while you are on vacation abroad?',
    options: [
      { id: 'q-vd-18o1', text: 'Continue driving; you are still covered' },
      { id: 'q-vd-18o2', text: 'Stop driving immediately; you are not covered' },
      { id: 'q-vd-18o3', text: 'Contact your insurer to arrange temporary coverage immediately' }
    ],
    answerId: 'q-vd-18o3',
    explanation: 'If your insurance expires while abroad, you must immediately contact your insurer to arrange temporary coverage. Driving without valid insurance is illegal and dangerous.',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-19',
    topic: 'General',
    question: 'What is a green card for vehicle insurance?',
    options: [
      { id: 'q-vd-19o1', text: 'A card showing your driving license is valid' },
      { id: 'q-vd-19o2', text: 'International insurance certification for driving abroad' },
      { id: 'q-vd-19o3', text: 'A card showing your APK inspection is valid' }
    ],
    answerId: 'q-vd-19o2',
    explanation: 'A green card is international insurance certification that proves your vehicle has third-party liability insurance that is valid in other countries. Many insurers include it automatically.',
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-20',
    topic: 'General',
    question: 'What penalty applies if you drive without valid insurance?',
    options: [
      { id: 'q-vd-20o1', text: 'Warning only' },
      { id: 'q-vd-20o2', text: 'Fine starting from €790 and possible vehicle impoundment' },
      { id: 'q-vd-20o3', text: 'Fine of €50' }
    ],
    answerId: 'q-vd-20o2',
    explanation: 'Driving without valid insurance is a serious offense that results in a fine starting from €790, possible points on your license, and potential vehicle impoundment. (RVV 1990 art. 107)',
    subject: 'Vehicle Documentation'
  }
];
